var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.134,
    height: 17.638,
    viewBox: "1880 8803.189 29.134 17.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "noun-view-7456262"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1909.004 8811.523a16.672 16.672 0 0 0-28.874 0 .97.97 0 0 0 0 .97 16.672 16.672 0 0 0 28.874 0 .97.97 0 0 0 0-.97Zm-14.437 7.362a14.775 14.775 0 0 1-12.462-6.877 14.73 14.73 0 0 1 24.924 0 14.774 14.774 0 0 1-12.462 6.877Zm4.855-6.877a4.85 4.85 0 0 1-1.422 3.433 4.85 4.85 0 0 1-6.866 0 4.85 4.85 0 0 1 0-6.866 4.85 4.85 0 0 1 6.866 0 4.85 4.85 0 0 1 1.422 3.433Z",
    fillRule: "evenodd",
    "data-name": "Path 10832"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c7cd162c6dcb2b6e57f7ba57caab73c9.svg";
export { ForwardRef as ReactComponent };